/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LocationFilterSchemaCategory = typeof LocationFilterSchemaCategory[keyof typeof LocationFilterSchemaCategory] | null;


export const LocationFilterSchemaCategory = {
  country: 'country',
  region: 'region',
  city: 'city',
} as const;
